import { useQuery } from '@tanstack/react-query';

import { fetchLADClaimPrintForm } from '../data-provider/lad-print-form';
import type { GetLADClaimPrintFormRequestParams } from '../data-provider/lad-print-form/api';

export const useGetLADPrintForm = ({
  enabled = true,
  ...params
}: GetLADClaimPrintFormRequestParams & { enabled?: boolean }) => {
  return useQuery({
    enabled: enabled && Boolean(params.ClaimKeys),
    queryFn: () => fetchLADClaimPrintForm(params),
    queryKey: ['claims-loss-and-damage-print-form', params.ClaimKeys],
  });
};
